import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import RegisterFirst from "../../../components/auth/registration/client/RegisterFirst";
// import RegisterForth from "../../components/main/RegisterForth";
import RegisterSecond from "../../../components/auth/registration/client/RegisterSecond";
import RegisterThird from "../../../components/auth/registration/client/RegisterThird";
import { setRegisterData, submitRegister } from "../../../store/actions/userActions";
import { setCountryList } from "../../../store/actions/common/commonActions";
import { useDispatch } from "react-redux";
const RegisterAsClient = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  // proceed to the next step
  const nextStep = () => {
    setStep(step + 1);
  };
  // go back to previous step
  const prevStep = () => {
    setStep(step - 1);
  };

  // const data_country_list = useSelector((state) => state.data_country_list);
  // const register_store_data = useSelector((state) => state);



  // const getCountryList = () => {
  //   return data_country_list.loading ? dispatch(setCountryList()) : null;
  // };


  useEffect (() => {
    const registerData = {
      user_title: "MR",
      first_name: "",
      last_name: "",
      email: "",
      contact_number: "",
      country: 0,
      state: 0,
      city: 0,
      password: "",
      role: 3, // 3 company, 4 = freelancer
      company_emp_no: "",
      company_department: "",
      newsletter: false,
      terms: false,
      address: '',
      lat: '',
      lang: ''
    };
    dispatch(setRegisterData(registerData));
    dispatch(submitRegister(1, {}));
    dispatch(setCountryList());
  }, [dispatch]);
  return (
    <>
      <Header />
      <div className="wt-haslayout wt-innerbannerholder">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-xs-12 col-sm-12 col-md-8 push-md-2 col-lg-6 push-lg-3">
              <div className="wt-innerbannercontent">
                <div className="wt-title">
                  <h2>Join Now For FREE</h2>
                </div>
                <ol className="wt-breadcrumb">
                  <li>
                    <a href="index.html">Home</a>
                  </li>
                  <li className="wt-active">Join Now</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(() => {
        switch (step) {
          case 1:
            return (
              <RegisterFirst
                step={step}
                nextStep={nextStep}
                prevStep={prevStep}
              />
            );
          case 2:
            return (
              <RegisterSecond
                step={step}
                nextStep={nextStep}
                prevStep={prevStep}
              />
            );
          case 3:
            return (
              <RegisterThird
                step={step}
                nextStep={nextStep}
                prevStep={prevStep}
              />
            );
          default:
            return (
              <RegisterFirst
                step={step}
                nextStep={nextStep}
                prevStep={prevStep}
              />
            );
        }
      })()}
      <Footer />
    </>
  );
};

export default RegisterAsClient;
